import axios from "axios";
import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../lib/UserContext";

const serverLink = process.env.REACT_APP_SERVER_URL;

const KeepInTouch = () => {
  const navigate = useNavigate();
  const [user, setUser] = useContext(UserContext);
  const [accounts, setAccounts] = useState([]);
  const [magic, setMagic] = useState<any>(null);
  const [web3, setWeb3] = useState<any>(null);
  const [name, setName] = useState(user.name);
  const [username, setUsername] = useState(user.userName);
  const [walletAddress, setWalletAddress] = useState(user.walletAddress);
  const [twitterUsername, setTwitterUsername] = useState(user.twitterUserName);
  const [discord, setDiscord] = useState(user.discordHandle);

  useEffect(() => {
    user && !user.userId && !user.userName && navigate("/login");
  }, [user, navigate]);

  const submitUserDetails = async () => {
      try {
        const userData = {name:name, email:user.email, userName:username, walletAddress:walletAddress, twitterUserName:twitterUsername, discordHandle:discord}
        const response = await axios.put(`${process.env.REACT_APP_SERVER_URL}/user`, userData, {
          'params' : {
            magicAccount: user.magicLinkAccount
          }
        });

        if(response.data.success){
          setUser({"userId":response.data.data._id, "userName":response.data.data.userName, "magicLinkAccount":response.data.data.magicAccount, "name":response.data.data.name, "email":response.data.data.email, "walletAddress": response.data.data.walletAddress, "twitterUserName": response.data.data.twitterUserName, "discordHandle": response.data.data.discordHandle})
          navigate("/profile");
        }
        else{
          alert('Failed')
        }
      } catch (error) {
        console.error('Error logging in:', error);
      }
  }

  return (
    <>
      <div className="bg-header h-screen font-inter">
        <div className="px-6 pt-6 lg:px-8">
          <nav className="flex items-center justify-between">
            <div className="flex lg:flex-1">
              <a href="" className="-m-1.5 p-1.5">
                <span className="sr-only">Celium</span>
                <img
                  className="h-14"
                  src={"image/celium-white.png"}
                  alt="celium-logo"
                />
              </a>
            </div>
          </nav>
        </div>
        <div className="container mx-auto">
          <div className="sm:flex flex-row gap-8">
            <div className="p-5 sm:p-10">
              <img
                src={"image/celium-explorer.png"}
                className="h-auto sm:p-20"
                alt="celium-explorer"
              />
            </div>
            <div className="pt-10 px-3 sm:px-0">
              <h1 className="text-4xl font-bold tracking-tight text-purple-500 sm:text-8xl font-inter whitespace-nowrap">
                Lets keep in touch {user.magicLinkAccount}
              </h1>
              <p className="text-2xl pt-4">
                To save your test results and be eligible for fun gifts from us
                in the future, please tell us a little bit about you...
              </p>

              <div className="pt-10">
                <input
                  value={name}
                  onChange={(event) => setName(event?.currentTarget.value)}
                  className="w-full text-white placeholder-white text-2xl leading-tight focus:outline-none focus:shadow-outline bg-transparent border-b-2 pt-5"
                  placeholder="Your Name (or pseudoym)*"
                  contentEditable={true}
                />
                <input
                  value={user.email}
                  className="w-full text-white placeholder-white text-2xl leading-tight focus:outline-none focus:shadow-outline bg-transparent border-b-2 pt-5"
                  placeholder="Email*"
                />
                <input
                  value={username}
                  onChange={(event) => setUsername(event?.target.value)}
                  className="w-full text-white placeholder-white text-2xl leading-tight focus:outline-none focus:shadow-outline bg-transparent border-b-2 pt-5"
                  placeholder="Username*"
                  contentEditable={true}
                />
                <input
                  value={walletAddress}
                  onChange={(event) => setWalletAddress(event?.currentTarget.value)}
                  className="w-full text-white placeholder-white text-2xl leading-tight focus:outline-none focus:shadow-outline bg-transparent border-b-2 pt-5"
                  placeholder="Wallet Address (0x only)"
                />
                <input
                  value={twitterUsername}
                  onChange={(event) => setTwitterUsername(event?.currentTarget.value)}
                  className="w-full text-white placeholder-white text-2xl leading-tight focus:outline-none focus:shadow-outline bg-transparent border-b-2 pt-5"
                  placeholder="Twitter Username"
                />
                <input
                  value={discord}
                  onChange={(event) => setDiscord(event?.currentTarget.value)}
                  className="w-full text-white placeholder-white text-2xl leading-tight focus:outline-none focus:shadow-outline bg-transparent border-b-2 pt-5"
                  placeholder="Discord Handle"
                />
                <button onClick={submitUserDetails} className="bg-blue-400 text-white font-bold py-3 px-8 focus:outline-none focus:shadow-outline rounded-3xl mt-5">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KeepInTouch;
